module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAASCAYAAAC5DOVpAAABEUlEQVQ4T62TvS5FURCFv4XQewCtlndQoLiFSiORCI1EdCokV6ci0ZGoSBQaCpVnUCtF7QEIlszNLvycufucxDS72DNf1tqztvjHUo1le9AjybXeFGZ7CjgCFoIF3AHbkp4yaCPM9iTwAATwez0Ds5JemoAZbBfoJwoOJO11gYWl+QR2L2muC+waWEpgt5J6XWCrwHkC25B02gU2CtwAi7+Gwn5P0ntrWDTaHgPWgMMyuAOcZaBBFmtBtP1YQjtd682icQysl+GJcr6WM9RttbZpexNYTpRcSTppBbM9A+wDsYSm+ohAS4of8qP+2LQdii6HvGd8+BVJF1VY2eQ4MJIo+5T01spmbWPD7qvR6AL/AhH1UBNWD2IyAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/static/images/product/qianyue_tab.png
// module id = YZZV
// module chunks = 1